/** Extensions allowed for canvas file uploads (Insert → Upload, Quick Add, etc.). */
export const CANVAS_FILE_UPLOAD_ACCEPT =
  ".pdf,.doc,.docx,.txt,.md,.csv,.xlsx,.xls,.jpg,.jpeg,.png,.gif,.webp,.avif,.heic,.heif";
